module.exports = __webpack_public_path__ + "static/media/login_background_standard.9f20b465.jpg";